<template>
    <div class="change-user-img-component-container">
        <div class="component-wrappe scroll-bar">
            <div class="change-user-img-container">
                <div v-if="!uploadSuccess" class="change-user-img-wrapper">
                    <div v-if="loadingPage" class="spinner-container">
                        <div class="spinner">
                            <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                        </div>
                    </div>
                    <div class="change-user-img-content-container">
                        <div class="header-container">
                            <p>{{ $t('change_profile_img') }}</p>
                        </div>
                        <div class="upload-img-container">
                            <input id="inputFile" type="file" ref="imageInput" accept="image/*" name="image" capture="camera" hidden @change="handleFileChange">
                            <div class="img-area-container" :class="{'circle' : croppedImage}" ref="imgArea" data-img="">
                                <img class="user-profile-img" ref="profileImg" :src="uploadedImage" alt="">
                            </div>
                            <div v-if="imgName" class="img-info-container">
                                <div class="img-name-container">
                                    <p>{{ $t('file_name') }}: {{ imgName }}</p>
                                </div>
                                <div class="img-size-container">
                                    <p>{{ $t('file_size') }}: {{ imgSize }}KB</p>
                                </div>
                            </div>
                            <div class="select-img-btn-container">
                                <!-- <button class="select-img-btn" @click="selectImage">Select Image</button> -->
                                <button class="select-img-btn" @click="selectImage">{{ $t('select_image') }}</button>
                                <!-- <input id="inputFile" type="file" ref="imageInput" accept="image/*" @change="handleFileChange"> -->
                            </div>
                            <div class="error-msg-container">
                                <p v-if="errMsg" class="red">{{ $t(`${errMsg}`) }}</p>
                            </div>
                            <div class="img-size-tips-container">
                                <!-- <p>Afbeeldingsgrootte moet kleiner zijn dan <span>2MB</span></p> -->
                                <p>{{ $t('image_size_less_than_2MB') }}</p>
                            </div>
                        </div>
                        <div class="action-btns-container">
                            <div class="btn-container cancel-btn-container">
                                <!-- <div class="cancel-btn" @click="closeChangeUserProfileImgPage(false)">Annuleren</div> -->
                                <div class="btn cancel-btn" @click="closeChangeUserProfileImgPage(false)">
                                    <img src="../../assets/icons/cancel_icon.png" alt="">
                                </div>
                            </div>

                            <div class="btn-container save-btn-container" :class="!imgName ? 'disabled-btn-container' : 'enabled-btn-container'" @click="uploadNewImgProfile">
                                <!-- <div class="save-btn" :class="!imgName ? 'disabled-btn' : 'enabled-btn'" @click="uploadNewImgProfile">Opslaan</div> -->
                                <div class="btn save-btn">
                                    <img src="../../assets/icons/check.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-else class="img-uploaded-success-container">
                    <div class="img-uploaded-success-msg-container">
                        <p>{{ $t('profile_image_changed_successfully') }}</p>
                    </div>
                    <div class="ok-btn-container">
                        <div class="ok-btn" @click="closeChangeUserProfileImgPage(true)">{{ $t('ok') }}</div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
export default {
    name: "ChangeUserImgPage",
    data() {
        return {
            uploadedImage: null,
            imageInput: null,
            imgArea: null,
            profileImg: null,
            cropper: null,
            imgName: null,
            imgSize: null,
            errMsg: null,
            croppedImgDimensions: null,
            croppedImage: false,
            loadingPage: false,
            uploadSuccess: false,
            // imageDataFromMobileApp: false,
        };
    },
    methods: {
        closeChangeUserProfileImgPage: function(reloadPage) {
            this.uploadedImage = this.$store.user.profileImgUrl;
            this.imageInput = null;
            this.profileImg = null;
            if (this.cropper) {
                this.cropper.destroy();
                this.cropper = null;
            }
            this.imgName = null;
            this.imgSize = null;
            this.errMsg = null;
            this.croppedImgDimensions = null;
            this.croppedImage = false;
            this.loadingPage = false;
            this.uploadSuccess = false;
            this.$store.showChangeUserImgPage = false;
            if (reloadPage) {
                this.$store.reloadHeaderApp++;
            }
        },
        selectImage: async function() {
            // console.log('this.$store.requestSource: ' + this.$store.requestSource);
            if (this.$store.requestSource.includes("webView")) {
                // console.log("Click from mobile app...");
                await window.flutter_webView_open_file_picker.postMessage(JSON.stringify({ url: "test" }));
            }
            else {
                // console.log("Click from browser...");
                this.imageInput.click();
            }
        },
        initializeCropper: function() {
            if (this.cropper) {
                this.cropper.destroy();
            }
            this.cropper = new Cropper(this.profileImg, {
                aspectRatio: 1,
                minCropBoxWidth: 150,
                minCropBoxHeight: 150,
                background: false,
                cropBoxMovable: true,
                cropBoxResizable: true,
                // Add the crop event listener
                crop: () => {
                    // Get the cropped area's dimensions
                    const cropData = this.cropper.getData();
                    this.croppedImgDimensions = {
                        width: Math.round(cropData.width),
                        height: Math.round(cropData.height),
                    };
                },
            });
        },
        handleFileChange: function() {

            // if (this.$store.requestSource.includes("webView")) {
            //     const imageData = this.imageDataFromMobileApp;
            //     const image = this.imageInput;
            //     if (imageData) {
            //         if (imageData.type.startsWith('image/')) {
            //             if (imageData.size < 2097152) {
            //                 this.imgName = imageData.name;
            //                 this.imgSize = Math.round(imageData.size / 1024);
            //                 this.errMsg = null;

            //                 // Create a URL for the image
            //                 const fileUrl = URL.createObjectURL(image);

            //                 const reader = new FileReader();
            //                 reader.onload = () => {
            //                     this.uploadedImage = fileUrl;
            //                     this.initializeCropper();
            //                     if (this.cropper) {
            //                         this.cropper.replace(fileUrl);
            //                     }
            //                 };
            //                 reader.readAsDataURL(image);
            //             }
            //         }
            //     }
            // }
            // else {
                if (this.imageInput.files[0]) {
                    const image = this.imageInput.files[0];
                    // console.log("Display image details:");
                    // console.log(image);
                    if (image.type.startsWith('image/')) {
                        // console.log(image);
                        if (image.size < 5242880) {
                            this.imgName = image.name;
                            this.imgSize = Math.round(image.size / 1024);
                            this.errMsg = null;
                            const reader = new FileReader();
                            reader.onload = () => {
                                const imgUrl = reader.result;
                                this.uploadedImage = imgUrl;
                                this.initializeCropper();
                                if (this.cropper) {
                                    this.cropper.replace(imgUrl);
                                }
                            };
                            reader.readAsDataURL(image);
                        } else {
                            this.errMsg = 'image_size_larger_5MB';
                        }
                    }
                    else {
                        this.errMsg = 'image_format_invalid';
                    }
                }
            // }
        },
        uploadNewImgProfile: async function() {
            // console.log("Starting upload profile image...");
            this.uploadSuccess = false;
            this.errMsg = null;
            if (!this.imgName) {
                this.errMsg = 'select_image';
            }
            else {
                try {
                    this.loadingPage = true;
                    const fileName = `${this.$store.user.zohoId}.png`;
                    const blob = await new Promise((resolve) => {
                        // Convert the canvas to a Blob
                        this.cropper.getCroppedCanvas({
                            width: this.croppedImgDimensions.width,
                            height: this.croppedImgDimensions.height,
                        }).toBlob((blob) => {
                            const file = new File([blob], fileName, {type: 'image/png'});
                            resolve(file);
                        });
                    });

                    // console.log("Printing Blob...");
                    // console.log(blob);


                    // ===================================

                    // // Create a cropped image from the uploaded one to display it instead of the uploaded image
                    // // Create a new file from the Blob
                    // const imageType = 'image/png';
                    // const customName = `${this.$store.user.zohoId}.png`;
                    // const croppedImageFile = new File([blob], customName, { type: imageType });
                    // // Handle the file upload or display the image
                    // const croppedImageUrl = URL.createObjectURL(croppedImageFile);
                    // this.uploadedImage = croppedImageUrl;
                    // console.log(croppedImageFile);
                    // console.log(croppedImageUrl);

                    // this.croppedImage = true;

                    // ===================================

                    // Create a cropped image to save it on the server
                    // Create a new FormData
                    const formData = new FormData();
                    // formData.append('uploadImg', blob, fileName);
                    formData.append('uploadImg', blob);

                    // Add the description of the image to know in which folder it should be saved on the server
                    formData.append('imgDesc', 'profileImg');

                    // Send action type (create or update)
                    // formData.append('actionType', 'create'); // This action type will be used with uploading images of countries flags and homepage cards images

                    // console.log("Printing formData...");
                    // console.log(formData);

                    // Get user data from local storage.
                    const localStorageUser = JSON.parse(localStorage.getItem('user'));
                    if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                        this.$store.showErrorPopup = true;
                        this.$store.errorPopupTitle = 'logout';
                        this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                        this.$store.mustLogOut = true;
                    }
                    else {
                        formData.append('email', localStorageUser.email);
                        formData.append('token', localStorageUser.token);

                        const uploadProfileImgResponse = await fetch('/api/bucket/uploadImg', {
                            method: "POST",
                            body: formData,
                        });

                        const uploadProfileImgResponseJson = await uploadProfileImgResponse.json();

                        // console.log("Printing uploadProfileImgResponseJson...");
                        // console.log(uploadProfileImgResponseJson);

                        // console.log("Printing uploadProfileImgResponseJson status...");
                        // console.log("uploadProfileImgResponseJson.status: " + uploadProfileImgResponseJson.status);

                        if (!uploadProfileImgResponseJson.status) {
                            if (uploadProfileImgResponseJson.invalidToken) {
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'logout';
                                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                                this.$store.mustLogOut = true;
                            }
                            else {
                                this.errMsg = 'something_went_wrong_try_again';
                                // Close the cropper box
                                if (this.cropper) {
                                    this.cropper.destroy();
                                }
                                this.cropper = null;
                            }
                        }
                        else {
                            if (uploadProfileImgResponseJson.url) {
                                this.$store.user.profileImgUrl = uploadProfileImgResponseJson.url;
                                this.$store.setCookie('user', JSON.stringify(this.$store.user), 30);
                            }
                            // this.$store.user.profileImgUrl = uploadProfileImgResponseJson.urls;
                            this.$store.setCookie('user', JSON.stringify(this.$store.user), 30);
                            this.$store.errorPopupTitle = "success";
                            this.$store.errorPopupMsg = "profile_image_changed_successfully";
                            this.uploadSuccess = true;
                            this.$store.showChangeUserImgPage = false;
                            this.$store.showErrorPopup = true;
                        }
                        this.loadingPage = false;

                        // Close the cropper box
                        if (this.cropper) {
                            this.cropper.destroy();
                        }
                        this.cropper = null;
                    }
                }
                catch(err) {
                    console.log("Error uploading profile image...");
                    console.log(err);
                    console.log(err.message);
                    this.errMsg = 'something_went_wrong_try_again';
                    // Close the cropper box
                    if (this.cropper) {
                        this.cropper.destroy();
                    }
                    this.cropper = null;
                }
            }
        },
        // triggerFileInput() {
        //     console.log("Trigger File Input...");
        //   this.$refs.imageInput.click();
        // },
    },
    created() {
        window.addEventListener('filePicked', async (event) => {
            // console.log("filePicked...");
            // console.log(event);
            const response = event.detail;
            // const response = JSON.parse(event.detail);
            // const { status } = response;
            // console.log("response: " + response);
            // console.log("response.status: " + response.status);
            
            this.errMsg = null;

            if (!response.status) {
                this.errMsg = response.message;
            }
            else {            
                // Decode base64 string to binary data
                const byteCharacters = atob(response.data.img);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                // Create a Blob from the binary data
                const blob = new Blob([byteArray], { type: 'image/*' });
                
                this.imgName = response.data.name;
                this.imgSize = Math.round(response.data.size / 1024);

                // Create a URL for the Blob
                const fileUrl = URL.createObjectURL(blob);
                const reader = new FileReader();
                reader.onload = () => {
                    this.uploadedImage = fileUrl;
                    this.initializeCropper();
                    if (this.cropper) {
                        this.cropper.replace(fileUrl);
                    }
                };
                reader.readAsDataURL(blob);
            }
        });
    },
    mounted() {
        this.uploadedImage = this.$store.user.profileImgUrl;
        this.imageInput = this.$refs.imageInput;
        this.profileImg = this.$refs.profileImg;
        // window.triggerFileInput = this.triggerFileInput(); // Expose the method to the global window object
    },
    beforeDestroy() {
        if (this.cropper) {
            this.cropper.destroy();
        }
    }
}
</script>

<style>
@import 'cropperjs/dist/cropper.css';

.change-user-img-component-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(255, 255, 255, 0.75);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
}

.change-user-img-component-container .component-wrappe {
    flex: 1;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.change-user-img-component-container .change-user-img-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
}

.change-user-img-component-container .change-user-img-wrapper {
    position: relative;
    width: 90%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.change-user-img-component-container .spinner-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, .8);
    z-index: 200;
    display: flex;
    justify-content: center;
    align-items: center;
}

.change-user-img-component-container .spinner {
    width: 20% !important;
    max-width: 100px !important;
}

.change-user-img-component-container .spinner img {
    width: 100%;
}

.change-user-img-component-container .change-user-img-content-container {
    width: 100%;
    background: #ffffff;
    border-radius: 22px;
    overflow: hidden;
    border: 2px solid #92d400;
}

.change-user-img-component-container .header-container {
    padding: 10px;
    /* border-top: 1px solid #d6d9d9;
    border-bottom: 1px solid #d6d9d9;
    box-shadow: 0 0 5px 0 #E6E6E6; */
    /* border-radius: 22px; */
    background: #92d400;
    border-radius: 20px 20px 0 0;
}

.change-user-img-component-container .header-container p {
    font-family: 'Open Sans Std', sans-serif;
    font-weight: bold;
    font-size: 24px;
    color: #ffffff;
}

.change-user-img-component-container .upload-img-container {
    width: 100%;
    padding: 25px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.change-user-img-component-container .img-area-container {
    width: 90%;
    max-width: 300px;
    max-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.change-user-img-component-container .circle {
    border-radius: 50%;
    overflow: hidden;
}

.change-user-img-component-container .img-area-container img {
    width: 100%;
    height: auto;
    object-fit: cover;
	object-position: center;
    z-index: 100;
}

.change-user-img-component-container .img-size-tips-container {
    padding-top : 15px;
}

.change-user-img-component-container .img-name-container,
.change-user-img-component-container .img-size-container {
    padding-top: 15px;
}

.change-user-img-component-container .img-name-container p,
.change-user-img-component-container .img-size-container p {
    text-align: center;
}

.change-user-img-component-container .img-name-container p,
.change-user-img-component-container .img-size-container p,
.change-user-img-component-container .img-size-tips-container p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* Set the maximum number of lines */
    -webkit-line-clamp: 2; /* For WebKit-based browsers like Safari and Chrome */
    line-clamp: 2; /* Standard property */
    word-wrap: break-word;
    white-space: normal;
    font-family: 'Open Sans Std', sans-serif;
    color: #616365;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
}

.change-user-img-component-container .img-size-tips-container p::before {
    content: '* ';
}

.change-user-img-component-container .select-img-btn-container {
    width: 90%;
    max-width: 350px;
    margin-top: 15px;
}

.change-user-img-component-container .select-img-btn {
    width: 100%;
    color: #ffffff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 24px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 8px;
    background: #009df4;
    border: 1px solid #ffffff;
    border-radius: 30px;
    cursor: pointer;
}

.change-user-img-component-container .error-msg-container p {
    padding: 2px 8px;
    font-family: 'Open Sans Std', sans-serif;
    text-align: center;
}

.change-user-img-component-container .action-btns-container {
    /* padding: 15px 10px;
    display: flex;
    justify-content: space-evenly;
    align-items: center; */

    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 20px;
}

.change-user-img-component-container .btn-container {
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    padding: 1px 30px;
    overflow: hidden;
    cursor: pointer;
}

.change-user-img-component-container .cancel-btn-container {
    background: #cb061d;
}

.change-user-img-component-container .save-btn-container {
    margin-left: 40px;
}

[dir="rtl"] .change-user-img-component-container .save-btn-container {
    margin-right: 40px;
}

.change-user-img-component-container .enabled-btn-container {
    background: #92d400;
}

.change-user-img-component-container .disabled-btn-container {
    background: #616365;
}

.change-user-img-component-container .btn {
    /* width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 30px;
    border-radius: 30px;
    overflow: hidden;
    cursor: pointer; */

    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin: 5px 0;
}

.change-user-img-component-container .cancel-btn img {
    width: 70%;
}

.change-user-img-component-container .save-btn img {
    width: 90%;
}

/* .enabled-btn {
    background: #92d400;
}

.disabled-btn {
    background: #616365;
} */

/* .cancel-btn {
    background: #cb061d;
} */

.change-user-img-component-container .img-uploaded-success-container {
    background: #ffffff;
    width: 100%;
    max-width: 500px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 25px 0;
    border-radius: 10px;
}

.change-user-img-component-container .img-uploaded-success-msg-container {
    /* flex: 1; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid; */
}

.change-user-img-component-container .img-uploaded-success-msg-container p {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
}

.change-user-img-component-container .ok-btn-container {
    padding-top: 20px;
}

.change-user-img-component-container .ok-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 8px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

@media (max-width: 426px) {
    .change-user-img-component-container .change-user-img-wrapper {
        width: 80%;
    }
    .change-user-img-component-container .header-container p {
        font-size: 18px;
    }

    .change-user-img-component-container .img-area-container {
        width: 75%;
    }

    .change-user-img-component-container .img-name-container p,
    .change-user-img-component-container .img-size-container p,
    .change-user-img-component-container .img-size-tips-container p {
        font-size: calc(8px + 1vw);
    }

    .change-user-img-component-container .select-img-btn {
        font-size: 18px;
    }

    .change-user-img-component-container .error-msg-container p {
        font-size: 14px;
    }

    .change-user-img-component-container .action-btns-container {
        justify-content: space-evenly;
    }

    .change-user-img-component-container .btn-container {
        /* max-width: 125px; */
        height: 35px;
        padding: 1px 25px;
    }

    .change-user-img-component-container .btn {
        width: 35px;
    }

    .change-user-img-component-container .save-btn-container {
        margin: 0;
    }

    .change-user-img-component-container .img-uploaded-success-container {
        width: 90%;
    }

    .change-user-img-component-container .img-uploaded-success-msg-container p {
        font-size: 24px;
    }

    .change-user-img-component-container .ok-btn {
        min-width: 175px;
        font-size: 24px;
    }
}

@media (max-width: 375px) {
    .change-user-img-component-container .select-img-btn {
        font-size: calc(12px + 1vw);
    }

    .change-user-img-component-container .btn-container {
        height: 30px;
        padding: 1px 20px;
    }

    .change-user-img-component-container .btn {
        width: 30px;
    }

    .change-user-img-component-container .img-uploaded-success-container {
        width: 80%;
        min-height: 150px;
    }

    .change-user-img-component-container .img-uploaded-success-msg-container p {
        font-size: calc(12px + 2vw);
    }

    .change-user-img-component-container .ok-btn {
        min-width: 150px;
        font-size: 20px;
    }
}

@media (max-width: 320px) {
    .change-user-img-component-container .select-img-btn {
        font-size: calc(10px + 1vw);
    }

    .change-user-img-component-container .img-name-container p,
    .change-user-img-component-container .img-size-container p,
    .change-user-img-component-container .img-size-tips-container p {
        font-size: calc(6px + 1vw);
    }

    .change-user-img-component-container .save-btn-container, .cancel-btn-container {
        max-width: 90px;
    }

    .change-user-img-component-container .save-btn,
    .change-user-img-component-container .cancel-btn {
        font-size: 14px;
    }

    .change-user-img-component-container .img-uploaded-success-msg-container p {
        font-size: calc(12px + 1.5vw);
    }

    .change-user-img-component-container .ok-btn {
        min-width: 125px;
        font-size: 16px;
    }
}

</style>